<template>
  <!-- 试卷详情 -->
  <div class="paper-detail">
    <div class="tips" v-if="showTips">
      <p>该试卷已被如下套卷或考试使用：</p>
      <div v-if="tips.practise">
        <span class="tips-tag">套卷：</span>
        <span v-for="(item, index) in tips.practise" :key="index">《{{item}}》</span>
      </div>
      <div v-if="tips.simulation">
        <span class="tips-tag">考试：</span>
        <span v-for="(item, index) in tips.simulation" :key="index">《{{item}}》</span>
      </div>
    </div>
    <div class="paper-title">
      <div class="paper-info">
        <h4>{{info.package_name}}</h4>
        <pre v-if="type == 1">{{info.single_num}}道单选题  {{info.multi_num}}道多选题  {{info.judge_num}}道判断题  {{info.subject_num}}道简答题  共计{{info.score}}分</pre>
        <pre v-else>考试时长{{info.report_time_long}}   提交时间：{{info.created_at}}</pre>
      </div>
      <Button v-if="type == 1" icon="ios-download-outline" type="primary" @click="onDownload">下载试卷</Button>
      <p class="paper-point"  v-else-if="type != 5">{{info.point}}分</p>
    </div>
    <div class="paper-body">
      <section class="part" v-for="(item,index) in detail" :key="index">
        <pre class="part-title">第{{index+1}}部分：{{item.section.name}}   {{item.section.introduce}}（共{{item.section.total_num}}道题）</pre>
        <div class="question-item" v-for="question in item.question" :key="question.id">
          <div class="item-title">
            <font>{{question.question_sort}}.</font>
            <p class="ques-stem" v-html="question.ques_stem"></p>
            <font class="ques-type">{{getQuesType(question.ques_type)}} <span  v-if="type!=5">{{question.score}}分</span></font>
            <p class="ques-anwer" v-if="type==2 || type==5">
              <span>|</span>
              <font>选项：{{question.user_answer}}</font>
              <span
                class="user-flag"
                :class="{'hover-color':question.is_right==1}"
              >{{question.is_right==1 ? "正确":'错误'}}</span>
            </p>
          </div>
          <div v-if="question.ques_type==4" class="line-question">
            <div class="left-part">
              <div v-for="(optionL, idxL) in question.ques_option.left" :key="idxL">
                <span>{{idxL+1}})</span>、
                <div class="ques-stem" v-html="optionL.content"></div>
              </div>
            </div>
            <div class="right-part">
              <div v-for="(optionR, idxR) in question.ques_option.right" :key="idxR">
                <span>{{sort[idxR]}})</span>、
                <div class="ques-stem" v-html="optionR.content"></div>
              </div>
            </div>
          </div>
          <div v-else-if="question.ques_type==5" class="subject-question">
            <div v-html="question.right_answer">
            </div>
          </div>
          <ul v-else class="options" v-for="(option, i) in question.ques_option" :key="i">
            <li>
              <font>{{sort[i]}}、</font>
              <div class="ques-stem" v-html="option.content"></div>
            </li>
          </ul>
          <p class="answer" v-if="type == 1" @click="question.open_anwser = !question.open_anwser">
            <Icon type="ios-search" />展开答案解析
          </p>
          <div class="answer-info" v-show="type == 1 && question.open_anwser">
            <p v-if="question.ques_type!=5">
              正确答案
              <font>{{question.anwser}}</font>
              <font>考点： {{question.point_name ? question.point_name:'暂无考点'}}</font>
            </p>
            <div>
              题目解析：
              <div v-if="question.ques_analysis" class="ques-stem" v-html="question.ques_analysis"></div>
              <div v-else class="ques-stem">暂无解析</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import { QuestionType } from "@/utils/enums";
export default {
  name: "paper-detail",
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type || 1, //1试卷详情 2学生做题记录
      info: {},
      detail: {},
      tips: null,
      sort: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      spinShow:true
    };
  },
  methods: {
    // on event
    onDownload() {
      this.$http.get(`/api/exam/download/${this.id}`).then(data => {
        window.open(data.url);
      });
    },
    // other
    getQuestion() {
      this.$http.get(this.url).then(res => {
        this.info = res.package;
        this.info.created_at = this.$pub.timestampToTime(this.info.created_at);
        let question_sort = 1;
        res.detail.forEach(item => {
          let section = item.section;
          section.name = section.name || section.section_name;
          section.introduce = section.introduce || section.section_description;
          section.total_num = section.total_num || section.section_question_num;
          item.question.forEach(it => {
            it.open_anwser = 0;
            it.question_sort = question_sort++;
            it.anwser = "";
            if (it.ques_type == 4) {
              it.ques_option.left.forEach(option => {
                // 仅包含一对一
                it.anwser += this.sort[option.is_right - 1] + ",";
              });
              it.anwser = it.anwser.substr(0, it.anwser.length - 1);
              if (this.type == 2 || this.type == 5) {
                if (it.user_answer) {
                  let user_answer = JSON.parse(it.user_answer);
                  it.user_answer = "";
                  user_answer.forEach(ans => {
                    it.user_answer += this.sort[ans.answer - 1] + "、";
                  });
                  it.user_answer = it.user_answer.substr(
                    0,
                    it.user_answer.length - 1
                  );
                }
              }
            }else if( it.ques_type == 5 ) { //简答

             } else {
              it.ques_option.forEach((option, idx) => {
                if (option.is_right == 1) {
                  it.anwser += this.sort[idx];
                }
              });
              if (this.type == 2|| this.type == 5) {
                if (it.user_answer) {
                  let user_answer = JSON.parse(it.user_answer);
                  it.user_answer = "";
                  user_answer.forEach(ans => {
                    it.user_answer += this.sort[ans.id - 1];
                  });
                }
              }
            }
          });
        });
        this.detail = res.detail;
        this.tips = res.tips;
      });
    },
    getQuesType(type) {
      return QuestionType.getValue(type);
    }
  },
  computed: {
    url() {
      if (this.type == 2) {
        let type = "simulation";
        if (this.$route.name == "StudentPaperDetail") {
          type = "practice";
        }
        return `/api/exam/${type}/reportShowDetail?report_id=${this.id}&paper_id=${this.$route.query.paper_id}`;
      } if (this.type == 5) {
        return `/api/exam/exercise-report/reportShowDetail?report_id=${this.id}&paper_id=${this.$route.query.paper_id}`;
      } else {
        return `/api/exam/detail/${this.$route.query.id}`;
      }
    },
    showTips() {
      const result = JSON.stringify(this.tips);
      return result && result != "null" && result != "{}" && result != "[]";
    }
  },
  mounted(){
    let _this = this;
    if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
        this.MathJax.initMathjaxConfig()
    }
    setTimeout(function(){
      _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
      _this.spinShow = false;
    },2000)
  },
  created() {
    this.getQuestion();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
pre {
  margin: 10px 0;
}
.paper-detail {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .tips {
    .tips-tag {
      color: $primary_color;
    }
  }
  .paper-title {
    display: flex;
    padding: 10px 30px;
    button {
      height: 40px;
      /deep/ i {
        font-size: 16px;
      }
    }
    .paper-info {
      flex: 1;
      text-align: center;
      h4 {
        font-size: 18px;
        line-height: 30px;
      }
      pre {
        font-size: 13px;
      }
    }
  }
  .paper-body {
    padding: 0 20px;
    .part {
      .part-title {
        font-size: 14px;
        color: #333;
      }
      .question-item {
        padding-bottom: 10px;
        .item-title {
          line-height: 26px;
          font {
            color: #777;
            padding-right: 4px;
          }
          .ques-type {
            padding-left: 20px;
          }
          span {
            padding: 0 10px;
          }
          .user-flag {
            display: inline-block;
            padding: 0 2px;
            margin-left: 10px;
            border: 1px solid #ed4014;
            color: #ed4014;
            height: 17px;
            font-size: 12px;
            line-height: 17px;
          }
          .ques-anwer {
            display: inline;
          }
        }
        line-height: 34px;
        .options {
          padding-left: 14px;
          font {
            display: inline-block;
          }
        }
        .line-question {
          padding-top: 4px;
          display: flex;
          width: 700px;
          padding-left: 14px;
          justify-content: space-between;
          .left-part,
          .right-part {
            width: 42%;
            line-height: 26px;
          }
        }
        .answer {
          padding-left: 14px;
          color: #ed4014;
          cursor: pointer;
        }
        .answer-info {
          padding: 10px 20px 20px;
          margin-left: 14px;
          background: #f1f1f1;
          border-radius: 5px;
          p {
            font {
              &:nth-child(1) {
                color: #2d8cf0;
                padding-right: 30px;
              }
              &:nth-child(2) {
                color: #333;
              }
            }
            &:nth-child(2) {
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .paper-point {
    font-size: 28px;
    color: #333;
  }
  .ques-stem {
    display: inline;
    /deep/ p {
      display: inline;
    }
    /deep/ img {
      max-width: 200px;
    }
    /deep/ h1,
    h2,
    h3,
    h4,
    h5 {
      display: inline;
    }
  }
  .hover-color {
    color: #2d8cf0 !important;
    border-color: #2d8cf0 !important;
  }
}
</style>
